import axios from "axios";
axios.defaults.baseURL = "";

export default axios;
